<template>
  <div class="hello" :style="showCouponModal ? 'height:98vh;overflow:hidden;' : ''">
    <Header
      :isShow="panelShow"
      :showCity="showCity"
      @selectCity="selectCity"
      :cartPros="cartPros"
      :cityInfo="cityInfo"
    />
    <div class="aaabox">
      <header-nav :showType="showType" :showPerson="true" />
      <type-nav :isIndex="false" :noJump="true" @getData="getData" />
    </div>
    <!-- 活动背景header-->  
    <div class="activity_back" v-if="GetPromBackGround">
       <img :src="GetPromBackGround.TopPic" alt="">
    </div>
    <div class="swiper">
      <!-- <EperSwiper :banner="PcBanner" height="400" isShowArrow="true" /> -->
      <NewEperSwiper :banner="PcBanner" height="400" isShowArrow="true" v-if="PcBanner.length" />
      <div class="swiper-button-prev"></div>
		  <div class="swiper-button-next"></div>
    </div>
    <div class="box_contain" >
      <!-- 活动背景left-->
      <div class="activity_left" v-if="GetPromBackGround" :style="{'height':Active_Height+'px'}">
        <img v-for="(item,index) in imageNum" :key="index" :src="GetPromBackGround.LeftPic" alt="" />
      </div>
      <div class="box_center" ref="ref1">
        <div class="container">
          <!-- v-if="isShowPrompt && notice != ''" -->
          <div class="prompt clearfix" v-if="notice != ''">
            <div class="prompt_ipl">
              <p class="promptImg fl">
                <img src="../assets/icon/header/prompt_icon.png" alt="" />
              </p>
              <marquee class="fl" behavior="" direction="" width="970">
                {{ notice }}
              </marquee>
            </div>
          </div>
          <div class="Promotion">
            <div class="module clearfix">
              <div
                class="module-unit"
                v-for="(item, key) in countryPro"
                :key="key"
                
              >
                <img
                  class="img"
                  style="width: 250px; height: 100px"
                  :src="item.fileName"
                  alt=""
                  @click.stop="common.linkList(item)"
                  v-if="key < 3"
                />
              </div>
            </div>
            <div class="eper_box">
              <div
                class="item fl"
                v-for="(upad, i) in allData.UpAd"
                :key="i"
                @click="common.linkList(upad)"
                v-if="i < 4"
              >
                <div class="main">
                  <!-- <img class="img"
                      :src="upad.fileName"
                      alt="EperClub Store" v-if="i == 0"> -->
                  <img class="img" :src="upad.fileName" alt="EperClub Store" />

                  <div class="mask" v-if="showMask == i">
                    <div class="inner">
                      <p class="view">{{ $t("index.toview") }}</p>
                      <p class="txt">{{ upad.info }}</p>
                    </div>
                  </div>
                </div>
                <p :class="['text', { active: showMask == i }]">
                  {{ upad.AdName }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="ad mad">
          <EperSwiper :banner="MidList" height="300" />
        </div>
        <!--普通专区-->
        <div class="area" v-for="(z, k) in allData.ZhuanQu" :key="k">
          <template v-if="z.List && z.List.length > 0">
            <sub-title :title="z.Adsense.AdName ? z.Adsense.AdName.toUpperCase() : ''">
              <p class="subtitle-discription-text">{{ z.Adsense.info }}</p>
            </sub-title>
            <div
              class="content"
              style="height: 496px"
              v-if="z.List && z.List.length > 0"
            >
              <EperProductList
                :productList="z.List"
                :fromHomeSale="true"
                :isEperbox="z.Adsense.TypeId == 'eperbox' ? true : false"
              />
            </div>
            <sub-footer
              :TypeId="z.Adsense.TypeId"
              :WebFunctionID="z.Adsense.WebFunctionID"
              :isEperbox="z.Adsense.TypeId == 'eperbox' ? true : false"
            />
            <div
              v-if="z.FloorBottomAd.fileName && z.FloorBottomAd.fileName != ''"
              class="ad"
              style="margin-top: 80px"
              @click.stop="common.linkList(z.FloorBottomAd)"
            >
              <img :src="z.FloorBottomAd.fileName" class="img" />
            </div>
          </template>
        </div>

        <div
          v-if="BotAd.fileName && BotAd.fileName != ''"
          class="ad"
          @click.stop="common.linkList(BotAd)"
        >
          <img :src="BotAd.fileName" class="img" />
        </div>
        <!--优惠区域-->
        <div class="area">
          <template>
            <sub-title
              :title="OnSaleAd.AdName.toUpperCase()"
              :isRed="true"
              v-if="allData.OnSaleAd && allData.OnSaleAd.length > 0"
            >
              <p class="subtitle-discription-text">
                {{ OnSaleAd.info }}
              </p>
            </sub-title>
            <div
              class="content"
              style="height: 496px"
              v-if="allData.OnSale && allData.OnSale.length > 0"
            >
              <!-- <HCarousel :len="allData.OnSale.length" :cardCarousel="1022" :paginationFactor="258" :windowSize="4">
                <EperProductList :productList='allData.OnSale' :len="allData.OnSale.length" :liw="258" :fromHomeSale="true" />
              </HCarousel> -->
              <EperProductList
                :productList="allData.OnSale.slice(0, 4)"
                :len="allData.OnSale.length"
                :liw="258"
                :fromHomeSale="true"
              />
            </div>
            <sub-footer :areaid="OnSaleAd.WebFunctionID" :isIndexSale="true" />
          </template>
        </div>
      </div>
      <!-- 活动背景right-->
      <div class="activity_right" v-if="GetPromBackGround" :style="{'height':Active_Height+'px'}">
        <img v-for="(item,index) in imageNum" :key="index" :src="GetPromBackGround.RightPic" alt="" />
      </div>
    </div>
    <!-- 注册成功弹窗 -->
    <div class="registerSuccess" v-if="isAllowPopup">
      <div class="registerSuccess_content">
        <img class="close_btn" src="../assets/close-quick.png" alt="" @click="closeAllowPopup">
        <div class="title">{{ $t("CouponVersion.CouponVersion18") }}</div>
        <div class="title1" v-if="tejiapros.length > 0">{{ $t("CouponVersion.CouponVersion19") }}</div>
        <div class="title1_content" v-if="tejiapros.length > 0">
          <EperProductList
                :productList="tejiapros"
                :len="tejiapros.length"
                :liw="258"
                :fromHomeSale="true"
                :isList="true"
                :IsPopup="false"
                :isHomeTejia="true"
                :isToDetail="true"
                @addCartSuccess="addCartSuccess"
                :HomePageMessage="true"
              />
        </div>
        <div class="title2" v-if="recpros.length > 0">{{ $t("CouponVersion.CouponVersion20") }}</div>
        <div class="triangle">
          <div class="left_triangle" v-show="showLeftTriangle" @click="TranslationProductList('left')"></div>
          <div class="title2_content" v-if="recpros.length > 0">
            <EperProductList
                :productList="recpros"
                :len="recpros.length"
                :liw="258"
                :fromHomeSale="false"
                :isList="false"
                :IsPopup="false"
                @addCartSuccess="addCartSuccess"
                :TransStyle="TransStyle"
                :HomePageMessage="true"
              />
          </div>
          <div class="right_triangle" v-show="showRightTriangle" @click="TranslationProductList('right')"></div>
        </div>
        
        <div class="btn" @click="closeAllowPopup">{{ $t("CouponVersion.CouponVersion21") }}</div>
      </div>
    </div>
    <!-- 放弃福利弹框 -->
    <div class="Modal" v-if="showModal">
      <div class="Modal_title">{{ $t("CouponVersion.CouponVersion22") }}<br/>{{ $t("CouponVersion.CouponVersion23") }} </div>
      <div class="btn">
        <div class="ok" @click="closeAll">{{ $t("CouponVersion.CouponVersion24") }}</div>
        <div class="cancel" @click="showModal = false">{{ $t("CouponVersion.CouponVersion25") }}</div>
      </div>
    </div>
    <!-- 优惠券弹框 -->
    <div class="couponbox" v-if="showCouponModal">
      <div class="coupon_content">
        <img class="close_btn" src="../assets/close-quick.png" alt="" @click="showCouponModal = false">
        <div class="title">{{ $t("CouponVersion.CouponVersion1") }}</div>
        <div class="coupon_list">
          <NewCoupon :list="couponList" @HomePage="showCouponModal = false"></NewCoupon>
        </div>
        <div class="coupon_info">
          {{ $t("CouponVersion.CouponVersion2") }}
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import img from "../assets/picture/1.jpg";
import HCarousel from "@/components/public/hCarousel";
const EperSwiper = () => import("@/components/swiper");
const NewEperSwiper = () => import("@/components/newSwiper");
const EperProductList = () => import("@/components/productList");
const NewCoupon = () => import("@/components/public/Newcoupon");

import vSelectLang from "../components/index/selectLang.vue";
import vSelectCity from "../components/index/selectCity.vue";
import mixin from "../mixin";
import filter from "../plugins/filters";

export default {
  name: "index",
  mixins: [mixin],
  components: {
    EperSwiper,
    EperProductList,
    HCarousel,
    NewEperSwiper,
    NewCoupon
  },
  computed:{
    GetPromBackGround(){
      return JSON.parse(localStorage.getItem("promBackGround")) ? JSON.parse(localStorage.getItem("promBackGround")) : null;
    }
  },
  data() {
    return {
      lang: 2,
      isShowPrompt: true,
      PcBanner: [],
      MidList: [],
      BotAd: {},
      OnSaleAd: [],
      ZhuanQu: [],
      topImg: img,
      panelShow: false, //是否显示头部特殊广告
      show: true,
      showLang: false, //是否显示选择语言
      showCity: false, //是否显示选择城市
      showType: true, //头部是否显示 有机 素食  等图标
      showPerson: true, //头部是否显示 个人中心等图标
      showMask: null,
      countryPro: [],
      isIndex: true,
      allData: {},
      // 购物车数据展示
      cartPros: {},
      // 个人中心快速浏览商品
      // allBuyList:[],
      notice: "",
      // 导航栏右侧广告位
      advertiseSpace: [],
      allBuyList: [],
      cityInfo: {},
      Active_Height:'',
      imageNum:1,
      tejiapros:[],
      recpros:[],
      isAllowPopup:false,
      showModal:false,
      couponList:[],
      showCouponModal:false,
      showLeftTriangle:false,
      showRightTriangle:false,
      TransStyle:0
    };
  },
  created() {
    let registerSuccessSwitch = localStorage.getItem("registerSuccessSwitch") ? true : false;
    let Token = localStorage.getItem("Token");
    if(registerSuccessSwitch && Token){
      this.getRegisterSuccessList();
    }
    this.lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : 2;
    if (!filter.readData("TempId")) {
      const setUuid = filter.getUUID();
      filter.setData("TempId", setUuid);
    }
    if (!filter.readData("lang")) {
      this.showLang = true;
    }
  },
  mounted() {
    setTimeout(() => {
      this.panelShow = false;
    }, 10000);
    if (localStorage.getItem("lang") && localStorage.getItem("cityInfo")) {
      // this.getData();
    }
    this.editMeta();
  },
  methods: {
    TranslationProductList(direction){
      if(direction == "right"){
        this.TransStyle -= 154;
        this.showLeftTriangle = true;
      }else{
        this.TransStyle += 154;
      }
      if(this.TransStyle == 0){
        this.showLeftTriangle = false;
        this.showRightTriangle = true;
      }else if( -this.TransStyle >= (this.recpros.length - 4) * 154){
        this.showRightTriangle = false;
      }
      // console.log( - this.TransStyle,(this.recpros.length - 4) * 154);
    },
    ShowCoupon(){
      let nextShowCouponTemp = localStorage.getItem("nextShowCouponTemp");
      let nowTemp = Date.parse(new Date()) / 1000;
      if(Number(nextShowCouponTemp) + 86400 < nowTemp && this.couponList.length > 0){
          this.showCouponModal = true;
          localStorage.setItem("nextShowCouponTemp",nowTemp);
      }else{
        this.showCouponModal = false;
      }
    },
    closeAll(){
      this.isAllowPopup = false;
      this.showModal = false;
      localStorage.removeItem("isCartSuccess");
      localStorage.removeItem("registerSuccessSwitch");
    },
    closeAllowPopup(){
      let isCartSuccess = localStorage.getItem("isCartSuccess");
      if(isCartSuccess){
        this.isAllowPopup = false;
        localStorage.removeItem("isCartSuccess");
        localStorage.removeItem("registerSuccessSwitch");
      }else{
        this.showModal = true;
      }
    },
    addCartSuccess(data){
      localStorage.setItem("isCartSuccess",true);
    },
    getRegisterSuccessList(){
      this.$store.dispatch("GetRegTeJiaPros",{
        Token: localStorage.getItem("Token")
      }).then(res=>{
					this.tejiapros = res.Data.tejiapros;
					this.recpros = res.Data.recpros;
          if(res.Data.recpros.length > 4){
            this.showLeftTriangle=false;
            this.showRightTriangle=true;
          }
          if(res.Data.tejiapros.length > 0 || res.Data.recpros.length > 0){
					  this.isAllowPopup = true;
          }
				})
    },
    //修改meta 标签
    editMeta() {
      let _this = this;

      this.$store
        .dispatch("GetMeta", {
          ProductCataID: 0,
          LanguageType: this.lang,
        })
        .then((res) => {
          let viewport = document.querySelector("meta[name=keywords]");
          viewport.setAttribute("content", res.Data.KeyWords);
          let description = document.querySelector("meta[name=description]");
          description.setAttribute("content", res.Data.DeScription);
          document.title = res.Data.Title;
        });
    },
    getData(data) {
      const _this=this;
      this.$Loading.start();
      
      if (localStorage.getItem("lang") && localStorage.getItem("cityInfo")) {
        // this.getData();
        // let _this = this;
        let Data = data ? data : [];
        this.couponList = Data.CashvoucherlistNew;
        this.ShowCoupon();
        this.allData = Data;
        this.PcBanner = Data.PcBanner;
        (this.MidList = Data.MidList), (this.BotAd = Data.BotAd);
        if (Data.OnSaleAd.length != 0) {
          this.OnSaleAd = Data.OnSaleAd[0];
        }
        this.ZhuanQu = Data.ZhuanQu;
        this.allBuyList = Data.AllbuyList;
        this.notice = Data.Notice;
        this.advertiseSpace = Data.CataRightPlace;
        this.notice = Data.Notice;
        this.countryPro = Data.TuiGuang;
        setTimeout(()=>{
          _this.Active_Height=  this.$refs.ref1.offsetHeight;
          // 1186图片的高度
          _this.imageNum=Math.ceil(_this.Active_Height/1376);
        },1000)
        this.hideNotice();
      }

      this.$Loading.finish();

      // this.$store.dispatch('GetPCHome', {
      //   Token: localStorage.getItem('Token') ? localStorage.getItem('Token') : ''
      // }).then(({Data}) => {
      //   console.log(Data);
      //   this.allData = Data;
      //   this.PcBanner = Data.PcBanner;
      //   this.MidList = Data.MidList,
      //   this.BotAd = Data.BotAd;
      //   if(Data.OnSaleAd.length != 0){
      //     this.OnSaleAd = Data.OnSaleAd[0]
      //   }

      //   this.ZhuanQu = Data.ZhuanQu;
      //   this.allBuyList = Data.AllbuyList;
      //   this.notice = Data.Notice;
      //   this.advertiseSpace = Data.CataRightPlace;
      //   this.notice = Data.Notice;
      //   this.countryPro = Data.TuiGuang;
      //   _this.$Loading.finish();
      //   this.hideNotice()

      // })
    },
    //30秒后隐藏公告
    hideNotice() {
      this.timer = setTimeout(() => {
        this.isShowPrompt = false;
      }, 30000);
    },
    toRegister() {
      this.$router.push("/login");
    },
    closeCity(data) {
      this.showCity = data;
    },
    getCity(data) {
      this.cityInfo = data;
    },
    closeLang(data) {
      this.showLang = data;
    },
    selectCity(data) {
      this.showCity = data;
    },
    maskEnter(val) {
      this.showMask = val;
    },
    maskLeave() {
      this.showMask = null;
    },
    goTargetPage(upad) {
      let linkUrl = "";
      if (upad.TypeId == "RedemptionShow") {
        //积分商城
        linkUrl = "/integralMall";
      } else if (upad.TypeId == "anxinpei") {
        //每月营养
        linkUrl = "/monthlyNutrition";
      } else if (upad.TypeId == "area") {
        //赢品质
        linkUrl = `/category?WebFunctionID=${upad.WebFunctionID}&isShowSelect=0`;
      } else if (upad.TypeId == "rainbow") {
        //彩虹早餐
        linkUrl = "/rainbow";
      } else if (upad.TypeId == "eperbox") {
        //eperbox
        linkUrl = "/eperBox";
      } else if (upad.TypeId == "boutique") {
        //菩提客
        linkUrl = "/supplier";
      } else if (upad.TypeId == "sales") {
        linkUrl = "/sale";
      }
      window.open(linkUrl, "_blank");
    },
    toCategory(WebFunctionID) {
      this.$router.push({
        path: "/category",
        query: {
          ProductCataID: 0,
          isType: false,
          isFromType: false,
          isShowSelect: "",
          WebFunctionID,
        },
      });
    },

    // 获取头部购物车商品
    CartPros(data) {
      this.cartPros = data;
    },
  },
  destroyed() {
    this.timer && clearTimeout(this.timer);
  },
};
</script>

<style lang="scss" scoped>
@import "../style/color.scss";
@import "../style/transition.scss";
.swiper-button-prev {
  position: absolute;
	left: 20%;
	top: 180px;
	width: 32px;
	height: 63px;
	background: url(../assets/icon/left.png);
	background-position: 0 0;
	background-size: 100%;
  z-index: 100;
}
.swiper-button-next {
  position: absolute;
	right: 20%;
	top: 180px;
	width: 32px;
	height: 63px;
	background: url(../assets/icon/right.png);
	background-position: 0 0;
	background-size: 100%;
  z-index: 100;

}
// 注册成功样式
.hello .registerSuccess{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,.7);
  z-index: 2000;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard syntax */
  .registerSuccess_content{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 665px;
    // height: 775px;
    background: #FFFFFF;
    border-radius: 40px;
    padding: 16px 19px 23px 19px;
    .close_btn{
    width: 38px;
    height: 38px;
    position: absolute;
    top: 18px;
    right: 22px;
    cursor: pointer;
  }
    .title{
      font-weight: 800;
      font-size: 26px;
      color:$c_6DB;
      text-align: center;
    }
    .title1,.title2{
      text-align: center;
      font-size: 18px;
      font-weight: 400;
      color: #000;
    }
    .btn{
      width: 240px;
      height: 35px;
      background:$c_6DB;
      border-radius: 25px;
      line-height: 35px;
      text-align: center;
      margin: 0 auto;
      color: #fff;
      font-size: 19px;
      font-weight: bold;
      margin-top: 13px;
      cursor: pointer;
    }
    .title1_content,.title2_content{
      overflow: hidden;
      height: 257px;
      &::-webkit-scrollbar-thumb {
        border-radius: 0;
        height: 5px;
        -webkit-box-shadow: inset 0 0 6px #6FBF59;
        background: #6FBF59;
        border-radius: 3px;
        }
      &::-webkit-scrollbar {
        height: 8px;
      }
      &::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 6px #F6F8F7;
          border-radius: 0;
          background: #F6F8F7;
        }
      /deep/ .public{
        transform: scale(.6);
      }
      /deep/ .pruduct .public .public-ul{
        margin-left: -196px;
        .public-ul-li:nth-child(4n){
          margin-right: 10px !important;
        }
        .public-ul-li .pruduct-discription{
          height: auto;
        }
        .public-ul-li .pruduct-discription .pruduct-discription-prompt,
        .public-ul-li .pruduct-discription .pruduct-discription-origin,
        .public-ul-li .pruduct-discription .pruduct-discription-similar,
        .public-ul-li .pruduct-discription .pruduct-discription-remiand{
          display: none;
        }
      }
    }
    .triangle{
      position: relative;
      .title2_content{
        overflow: hidden;
      }
      .left_triangle{
        border-left: 12px solid transparent; /* 左边边框透明 */
        border-right: 12px solid #73B75B; /* 右边边框颜色 */
        border-top: 12px solid transparent; /* 顶部边框透明 */
        border-bottom: 12px solid transparent; /* 底部边框透明 */
        position: absolute;
        left: -14px;
        top: 50%;
        transform: translate(-50%,-50%);
        z-index: 100;
        cursor: pointer;
        transition: all 0.3s ease;
      }
      .right_triangle{
        border-left: 12px solid #73B75B ; /* 左边边框透明 */
        border-right: 12px solid transparent; /* 右边边框颜色 */
        border-top: 12px solid transparent; /* 顶部边框透明 */
        border-bottom: 12px solid transparent; /* 底部边框透明 */
        position: absolute;
        right: -38px;
        top: 50%;
        transform: translate(-50%,-50%);
        z-index: 100;
        cursor: pointer;
        transition: all 0.3s ease;

      }
    }
  }
}
.hello .Modal{
  width: 473px;
  height: 205px;
  background: #6EBE58;
  box-shadow: 0px 0px 6px 0px rgba(40,40,40,0.61);
  border-radius: 24px;
  position: fixed;
  z-index: 2001;
  top: 40%;
  left: 50%;
  transform: translate(-50%,-50%);
  .Modal_title{
    padding: 29px 37px;
    text-align: center;
    font-weight: 400;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 30px;
  }
  .btn{
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 37px;
    .ok,.cancel{
      width: 191px;
      height: 37px;
      background: #FFFFFF;
      border-radius: 18px;
      line-height: 37px;
      color: #000;
      font-size: 19px;
      font-weight: 400;
      text-align: center;
      cursor: pointer;

    }
  }
}
.hello .couponbox{
  -webkit-user-select: none; /* Chrome, Safari, Opera */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,.7);
  z-index: 2000;
  .coupon_content{
    width: 537px;
    // height: 729px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: #FFFFFF;
    border-radius: 40px;
    padding: 29px 28px;
    .close_btn{
      width: 38px;
    height: 38px;
    position: absolute;
    top: 18px;
    right: 22px;
    cursor: pointer;
    }
    .title{
      font-weight: 900;
      font-size: 34px;
      color: #6FBF59;
      line-height: 31px;
      text-decoration-line: underline;
      text-align: center;
    }
    .coupon_list{
      margin-top: 20px;
      min-height: 144px;
      max-height: 554px;
      overflow-y: scroll;
      overflow-x: hidden;
      /deep/ .coupons{
        margin: 0;
      }
      /deep/ .coupons-ul-li{
        width: 466px;
      }
      /deep/ .coupon .coupons-ul-li .item .btn_date .btn{
        // display: none;
      }
      &::-webkit-scrollbar-thumb {
        height: 5px;
        -webkit-box-shadow: inset 0 0 6px #6FBF59;
        background: #6FBF59;
        border-radius: 3px;
        }
      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 6px #F6F8F7;
          border-radius: 0;
          background: #F6F8F7;
        }
    }
    .coupon_info{
      margin-top: 20px;
      font-size: 16px;
      text-align: center;
      font-weight: bold;
    }
  }
}
.hello>.swiper{
  display: block;
  width: 100%;
  height: 400px;
  margin: 0 auto;
  position: relative;
}

.content {
  @include content;
}
.box_center{
  width:1050px;
}
// .aaabox{
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
// }
.mad {
  margin-bottom: 47px !important;
}
.activity_back {
  position: absolute;
  left: 0;
  top: 57px;
  z-index: -10;
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.activity_back img {
  display: block;
  // height: 205px;
  width: 1920px;
}

.box_contain {
  display: flex;
  justify-content: center;
  
  // background: url("../assets/activity/ac_center.jpg") no-repeat 50% 0;
}
.activity_left {
  overflow: hidden;
  margin-top: -88px;
  img{
    display: block;
  }
  // background: url("../assets/activity/618_left.jpg") repeat;
  background-size: 100% auto;
}
.activity_right {
  overflow: hidden;
  margin-top: -88px;
  img{
    display: block;
  }
  // background: url("../assets/activity/618_right.jpg") repeat;
  background-size: 100% auto;
}
.top_advertising {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;

  img {
    width: 100%;
    height: auto;
  }

  .swiper {
    position: relative;
  }

  // 首页顶部广告图过渡
  .slide-fade-enter-active {
    transition: all 0.8s ease;
  }

  .slide-fade-leave-active {
    transition: all 0.8s ease;
  }

  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
}

.container {
  .prompt {
    width: 100%;
    height: 34px;
    background: $c_f7f;
    line-height: 34px;
    font-size: $font-base;
    padding: 0 25px;
    box-sizing: border-box;
    .prompt_ipl {
      margin: 0 auto;
      width: 1050px;
    }
    .promptImg {
      width: 30px;
      height: 100%;

      img {
        width: 100%;
        height: 30px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }

  .Promotion {
    width: 1050px;
    margin: 0 auto;

    .module {
      width: 100%;
      padding: 10px 0;
      box-sizing: border-box;
      display: flex;
      .module-unit {
        // width: 33.333%;
        display: inline-block;
        flex: 1;
        justify-content: center;
        align-items: center;
      }
      .M_middle {
        margin-left: 200px;
        margin-right: 200px;
      }

      .img {
        width: auto;
        height: auto;
        display: block;
        margin: 0 auto;
        cursor: pointer;
      }
    }

    .eper_box {
      width: 100%;
      // height: 284px;
      clear: both;
      overflow: hidden;
      box-sizing: border-box;
      margin-bottom: 37px;
      .item {
        width: 25%;
        cursor: pointer;
        .main {
          position: relative;
          width: 100%;
          height: 185px;
          // height: 214px;

          .img {
            width: 262px;
            height: 185px;
            transition: all 0.35s ease-in-out;
          }

          .mask {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 214px;
            background: rgba(0, 0, 0, 0.5);
            // opacity: 0.5;
            transition: all 0.35s ease-in-out;

            .inner {
              width: 100%;
              height: 100%;
              padding: 80px 10px 20px 10px;
              box-sizing: border-box;
              overflow: hidden;

              .view {
                margin: 0 auto;
                width: 100px;
                height: 30px;
                color: $c_fff;
                font-size: 14px;
                text-align: center;
                line-height: 30px;
                border: 1px solid $c_fff;
                border-radius: 7px;
                margin-bottom: 30px;
              }

              .txt {
                text-align: center;
                color: $c_fff;
                font-size: 14px;
              }
            }
          }
        }

        .text {
          width: 100%;
          // height: 60px;
          text-align: center;
          // line-height: 60px;
          padding-top: 8px;
          font-size: $font_lg;
          font-family: "EperFontLight";
          color: #414142;
        }

        .text.active {
          background: #000;
          color: #fff;
        }
      }
    }
  }
}
.ad {
  @include content;
  .img {
    width: 100%;
    height: 200px;
  }
}
.area {
  margin-bottom: 80px;
  margin-top: 80px;
  .content {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    padding: 0 13px;
    box-sizing: border-box;
  }
}
/deep/ .pruduct .public .public-ul {
  border: none;
  padding: 0;
  .public-ul-li {
    width: 247px;
    cursor: pointer;
    &:nth-child(4n) {
      margin-right: 0 !important;
    }
    .public-ul-li-pictrue {
      width: 247px;
      .low-price {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 10;
        .ch_img {
          width: 55px;
          height: auto;
        }
      }
      // .discount {
      //   position: absolute;
      //   right: 10px;
      //   bottom: 32px;
      //   height: 36px;
      //   .discount_img {
      //     width: 71px;
      //     height: 36px;
      //   }
      // }
      .quality {
        position: absolute;
        width: 200px;
        height: 29px;
        bottom: 0;
        left: 50%;
        margin-left: -100px;
        .quality_img {
          width: 200px;
          height: 29px;
          display: block;
        }
      }
      .enQuality {
        position: absolute;
        width: 248px !important;
        height: 23px;
        bottom: 0;
        left: 38%;
        z-index: 77;
        margin-left: -93px !important;
        .quality_img {
          width: 248px !important;
          height: auto;
        }
      }
      .limittime {
        // position: absolute;
        // left: 0;
        // bottom: 35px;
        // height: 27px;
        .limittime_img {
          font-weight: normal;
          // width: 100px;
          // height: 27px;
        }
      }
      .exclusive {
        position: absolute;
        right: 0;
        bottom: 58px;
        // height: 77px!important;
        .exclusive_img {
          width: 110px;
          height: auto;
          max-height: 58px;
        }
      }
      .img {
        width: 248px;
        height: auto;
      }
      .icon {
        .img {
          width: 27px;
          height: 27px;
        }
      }
    }
    .pruduct-discription {
      height: 240px;
      padding: 18px;
      box-sizing: border-box;
      .pruduct-discription-prompt {
        height: 40px;
        line-height: 38px;
      }
      .pruduct-discription-origin {
        min-height: 28px;
        line-height: 28px;
        height: 28px;
      }
      &-all {
        // margin-top: -10px;
        .price {
          font-size: $font_llg;
        }
      }
    }
  }
}

/deep/ .card-carousel .pruduct .public .public-ul {
  border: none;
  padding: 0;
  overflow: hidden;
  zoom: 1;
  .public-ul-li {
    width: 248px;
    min-height: 417px;
    cursor: pointer;
    &:nth-child(4n) {
      margin-right: 10px !important;
    }
    .public-ul-li-pictrue {
      width: 248px;
      .img {
        width: 248px;
        height: auto;
      }
      .icon {
        .img {
          width: 27px;
          height: 27px;
        }
      }
    }
  }
}
>>> .discount {
  position: absolute;
  right: 6px;
  bottom: 30px !important;
  height: 36px;
  z-index: 77;
  .discount_img {
    width: auto;
    height: 36px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue